import SET_SELLER from './types';
export default {
  setSeller(_ref, payload) {
    var {
      commit
    } = _ref;
    commit(SET_SELLER, payload);
  }
};